export default class Color {

	public constructor (private red: number, private green: number, private blue: number, private alpha: number = 1) {}

	// Color origins: http://www.somersault1824.com/tips-for-designing-scientific-figures-for-color-blind-readers/
	// public static black () { return this.fromRGB(0, 0, 0); }
	public static white () { return this.fromRGB(255, 255, 255); }
	// public static sherpaBlue () { return this.fromRGB(0, 73, 73); } // This color doesn't clash but is very dark.
	public static cyan () { return this.fromRGB(0, 146, 146); } // dark cyan
	public static pink () { return this.fromRGB(255, 109, 182); } // hot pink
	public static pinkPale () { return this.fromRGB(255, 182, 219); } // cotton candy
	// public static purple () { return this.fromRGB(73, 0, 146); } // indigo //  // This color doesn't clash but is very dark.
	// public static navyBlue () { return this.fromRGB(0, 109, 219); } // This color officially clashes with dark cyan for tritanopians
	public static violet () { return this.fromRGB(182, 109, 255); } // heliotrope
	public static blueMatte () { return this.fromRGB(109, 182, 255); } // maya blue
	public static bluePale () { return this.fromRGB(182, 219, 255); } // columbia blue
	public static red () { return this.fromRGB(146, 0, 0); } // dark red
	// public static olive () { return this.fromRGB(146, 73, 0); } // This color is dark and looks too much like dark red for deuteranopians and protanoptians in my opinion
	// public static mangoTango () { return this.fromRGB(219, 109, 0); } // This color officially clashes with hot pink for tritanopians
	public static green () { return this.fromRGB(36, 255, 36); } // free speech green
	public static yellow () { return this.fromRGB(255, 255, 109); }  // laser lemon

	public getRed () {
		return this.red;
	}

	public getGreen () {
		return this.green;
	}

	public getBlue () {
		return this.blue;
	}

	public getAlpha () {
		return this.alpha;
	}

	public getArray () {
		return [this.red, this.green, this.blue, this.alpha];
	}

	private static fromRGB (red: number, green: number, blue: number) {
		return new Color(red / 255, green / 255, blue / 255);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/Color.ts